// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__3Z87D","FooterItem":"Footer_FooterItem__2ApLM","FooterLinks":"Footer_FooterLinks__2LSmd","Copyright":"Footer_Copyright__vQ0fB"};